import { getProgramData } from '~shared/api/single-program-data/single-program-data'

// ─── Component ────────────────────────────────────────────────────────────────

export const GraduateProfessionsSection = ({
  program
}: {
  program: Awaited<ReturnType<typeof getProgramData>>
}) => {
  const professions = program?.graduateProfessions

  if (!professions || professions.length === 0) return null

  return (
    <section
      className='py-[56px] 2lg:py-[80px] bg-[#F2F2F2]'>
      <div className='mx-auto px-[16px] box-border max-w-[672px] md:max-w-[864px] 2lg:max-w-[1280px]'>
        <h2 className='text-[32px] md:text-[40px] 2lg:text-[48px] font-medium leading-[120%] text-center mb-[32px] 2lg:mb-[48px]'>
          Кем вы сможете работать
        </h2>

        <ul className='grid grid-cols-1 gap-[16px]'>
          {professions.map((profession, idx) => (
            <li
              key={`GraduateProfessions__${profession?.name || idx}--${idx + 1}`}
              className='bg-white rounded-[16px] p-[16px] md:p-[24px]'>
              <p className='text-[16px] 2lg:text-[18px] leading-[140%]'>
                {profession?.name ?? ''}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
